import { initializeApp } from 'firebase/app';
import { EmailAuthProvider, getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

const testProduction = false;

let firebaseConfig = {
  apiKey: 'AIzaSyCKuVKvIiaYMes40k0Mk3DIqQObEeUVEDY',
  authDomain: 'bowlscout-staging.firebaseapp.com',
  projectId: 'bowlscout-staging',
  storageBucket: 'bowlscout-staging.firebasestorage.app',
  messagingSenderId: '854545421632',
  appId: '1:854545421632:web:f8ab4a64dc741d2a6916a5'
};

if (process.env.REACT_APP_ENVIRONMENT === 'production' || testProduction) {
  firebaseConfig = {
    apiKey: 'AIzaSyCieaor9yYHSQoVkaMw8xmlxFE5y25Trvo',
    authDomain: 'bowlscout.firebaseapp.com',
    projectId: 'bowlscout',
    storageBucket: 'bowlscout.firebasestorage.app',
    messagingSenderId: '1047908333781',
    appId: '1:1047908333781:web:b5308c6581c6020fc44a5c',
    measurementId: 'G-J8LG2K307M'
  };
}

const app = initializeApp(firebaseConfig);

const firestore = getFirestore(app);
const stripGsPrefix = (value) => String(value || '').replace(/^gs:\/\//, '');
const envStorageBucket = stripGsPrefix(process.env.REACT_APP_FIRBASE_STOREAGE);
const storageBucket =
  envStorageBucket && envStorageBucket.startsWith(`${firebaseConfig.projectId}.`)
    ? envStorageBucket
    : firebaseConfig.storageBucket;
const fireStorage = getStorage(app, `gs://${storageBucket}`);
// const analytics = getAnalytics(app);

export const auth = getAuth(app);
export const emailProvider = new EmailAuthProvider();
export const store = firestore;
export const storage = fireStorage;
//firebase login
//firebase init
//firebase deploy
